import { render, staticRenderFns } from "./ShowHistory.vue?vue&type=template&id=18a1128d"
import script from "./ShowHistory.vue?vue&type=script&lang=js"
export * from "./ShowHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports